export default "__VITE_ASSET__CsTddFfG__"